export interface CropNode { code: string; parentCode?: string | null; }

export function lineageOf(code: string | null | undefined, nodes: CropNode[]): string[] {
  if (!code) return [];
  const byCode = new Map((nodes || []).map(n => [n.code, n.parentCode || null]));
  const chain: string[] = [];
  const seen = new Set<string>();
  let cur: string | null = code;
  while (cur && !seen.has(cur)) {
    seen.add(cur);
    chain.push(cur);
    cur = byCode.has(cur) ? (byCode.get(cur) ?? null) : null;
  }
  return chain;
}
